import Ws from "../../providers/Ws";
import { EOVERFLOW } from "constants";

export default class AnalizeFurnizori{
    getFacturiAllNew = async() =>{
        let ds = await this.getDatasetLastMonths(24)
        let clienti = Array.from( this.getListaClientiUniciDinDataset(ds) ) ;

        let rez  = []

       

        let counter = clienti.length
        let counter2 = ds.length

       // console.log('ds :', ds);
       let facturiAll = [] 
        for(let i = 0 ; i< counter; i ++){
         
            
            for(let k = 0; k< counter2 ; k++){
                if(clienti[i]=== ds[k].localitate){
                    for(let l=k + 1; l<counter2; l++ ){
                        if(ds[l].localitate.indexOf('Total ')> -1){
                            break;
                        }
                      
                        if(ds[l].termen.indexOf('.') > -1){

                         
                       
                            let s = ds[l].termen.split('.')

                          //  console.log('s :', s);
                        if(s.length === 3){

                            // console.log('here 3 :');
                            let dataFact = new Date(s[2], s[1], s[0])

                            let dataCur = new Date()
                            ds[l].client = clienti[i]
                         
                                
                             
                            facturiAll.push(ds[l])
                            
                 
                              
                            

                        }
                        }
                        
                        
                      
                    }
                }
            }
        
        }
        return facturiAll
    }

    getFacturiNew = async () =>{
        let ds = await this.getDatasetLastMonths(24)
        let clienti = Array.from( this.getListaClientiUniciDinDataset(ds) ) ;

        let rez  = []

       

        let counter = clienti.length
        let counter2 = ds.length

       // console.log('ds :', ds);

        for(let i = 0 ; i< counter; i ++){
            let facturiInTermen =[]
        let facturiTermenDepasit = []
            
            for(let k = 0; k< counter2 ; k++){
                if(clienti[i]=== ds[k].localitate){
                    for(let l=k + 1; l<counter2; l++ ){
                        if(ds[l].localitate.indexOf('Total ')> -1){
                            break;
                        }
                      
                        if(ds[l].termen.indexOf('.') > -1){

                         
                       
                            let s = ds[l].termen.split('.')

                          //  console.log('s :', s);
                        if(s.length === 3){

                            // console.log('here 3 :');
                            let dataFact = new Date(s[2], s[1], s[0])

                            let dataCur = new Date()
                       
                         
                                facturiTermenDepasit.push(ds[l])
                            

                        }
                        
                        
                        
                    }
                    }
                }
            }
            if(facturiInTermen.length > 0 || facturiTermenDepasit.length > 0 ){

                rez.push({client:clienti[i],  facturiTermenDepasit:facturiTermenDepasit})
            }
        }
        return rez

     
        
    }

    getMonthData = async (an, luna) => {
        let ws = new Ws()
        let s = await ws.customSelect(`select * from pm.[dbo].fin_import_raport_lunar_furnizori_rows where id_head in ( select id from pm.[dbo].fin_import_raport_lunar_furnizori_head where an=@an and luna=@luna )`, { an: an, luna: luna })
      
       
        if(s.Succes)
            return s.Content
        else
            throw new Error(`Err get luna analizata ${luna} si an ${an} : ${s.Messsage}`)
    }

    getDatasetLastMonths = async (nr = null) => {
        
        let n = nr !== null ? nr : 12

        let rez = []
        //let dataCurenta = new Date();
        
        
        
        
        for (let i = 0; i < n; i++){
            
            //incepem de la luna anterioara:
            let dataCurenta = this.addMonths(new Date(), -1)

           
            let dataLunaTrecuta = this.addMonths(dataCurenta , -1 * i )

            let an = dataLunaTrecuta.getFullYear()
            let luna = 1+  dataLunaTrecuta.getMonth()

            let dateLuna = await this.getMonthData(an, luna)

            // console.log('dateLuna :', dateLuna);
            
            dateLuna.forEach(toAdd => {
                toAdd['an'] = an
                toAdd['luna'] = luna

                rez.push(toAdd)
            });
        }

        return rez;
    }

    getListaClientiUniciDinDataset = (ds) => {
        let rez = new Set();
        ds.forEach(c => {
            
            if (c['localitate'].indexOf('Total ') > -1) {
                rez.add(c['localitate'].replace('Total ',''))
            }
        })
        return rez;
    }
    addMonths = (dt, n) => {
        return new Date(dt.setMonth(dt.getMonth() + n));
    }
}